(function() {
  'use strict';

  angular
    .module('factories.serviceHelper', [
      'factories.authProvider',
      'factories.serviceLocator',
      'factories.alert',
      'factories.spinnerHelper'])
    .factory('ServiceHelper', ServiceHelper);

  ServiceHelper.$inject = ['$exceptionHandler', '$location', '$rootScope', '$window', 'Auth', 'SpinnerHelper',
    'serviceLocator', 'Alert', '$timeout', 'MobileHelper', 'gettext', 'translationService'];

  function ServiceHelper($exceptionHandler, $location, $rootScope, $window, Auth, SpinnerHelper, serviceLocator, Alert,
                         $timeout, MobileHelper, gettext, translationService) {

    var translate = translationService.sprintf;
    var knowErrors = ['CModuleArchived', 'CModuleDeleted', 'UserArchived', 'TraineeReinvited', 'SessionInvalid',
      'TraineeIsNotInvited', 'NotInCModule', 'ResetInCModule'];

    function isTrainerModeNavigationError(error) {
      return error && error.status === -1 && ($location.absUrl().indexOf('hideNavigationControls=1') > -1);
    }

    function isNetworkConnectionError(error) {
      // network connection error.status are 0
      return error && error.status === 0;
    }

    function isServerError(error) {
      return error && error.status >= 500 && error.status <= 511;
    }

    function isKnownError(error) {
      if (!error || !error.data || knowErrors.indexOf(error.data) === -1) {
        return null;
      }

      if (error.data === 'CModuleArchived') {
        return {
          message: null,
          messageUrl: 'modals/modalArchivedCModule.html',
          redirectLocation: serviceLocator.dashboardUrl(),
          logout: false
        };
      }
      if (error.data === 'CModuleDeleted') {
        return {
          message: null,
          messageUrl: 'modals/modalDeletedCModule.html',
          redirectLocation: serviceLocator.dashboardUrl(),
          logout: false
        };
      }
      // Deprecate - remove when .NET player backend is removed
      if (error.data === 'TraineeIsNotInvited') {
        return {
          message: null,
          messageUrl: 'modals/traineeNotInvited.html',
          redirectLocation: serviceLocator.dashboardUrl(),
          logout: false
        };
      }
      if (error.data === 'NotInCModule') {
        return {
          message: null,
          messageUrl: 'modals/traineeNotInvited.html',
          redirectLocation: serviceLocator.dashboardUrl(),
          logout: false
        };
      }
      // Deprecate - remove when .NET player backend is removed
      if (error.data === 'TraineeReinvited') {
        return {
          message: null,
          messageUrl: 'modals/traineeReinvited.html',
          redirectLocation: serviceLocator.dashboardUrl(),
          logout: false
        };
      }
      if (error.data === 'ResetInCModule') {
        return {
          message: null,
          messageUrl: 'modals/traineeReinvited.html',
          redirectLocation: serviceLocator.dashboardUrl(),
          logout: false
        };
      }
      if (error.data === 'SessionInvalid') {
        return {
          title: gettext("Your session has expired"),
          message: gettext("Please login to resume training."),
          logout: true
        };
      }
      if (error.data === 'UserArchived') {
        var logout = true;
        var redirectTo = serviceLocator.loginUrl();

        return {
          title: gettext('Account Inactive'),
          message: gettext('Sorry, your account appears to be inactive. You can contact your Trainer for more information.'),
          redirectLocation: redirectTo,
          logout: logout
        };
      }
      return null;
    }

    function errorHandler(errorCb) {
      return function(error) {
        errorCb = errorCb || angular.noop;

        var errorSettings = null;

        if (isTrainerModeNavigationError(error)) {
          return;
        }

        if (isNetworkConnectionError(error)) {

          // DE10846 error.status == 0 just return
          if (!MobileHelper.isIpad())
            return;

          errorSettings = {
            message: null,
            messageUrl: 'modals/connectionLost.html',
            logout: false
          };
        }

        var knownError = isKnownError(error);
        if (knownError) {
          errorSettings = knownError;
        } else if (!errorSettings && errorCb(error)) {
          // the callback is handling the error
          return;
        } else if (isServerError(error)) {
          errorSettings = {
            title: gettext('Error'),
            message: gettext('Oops, an unexpected server error occurred. Please try again.')
          };
        }

        var options = _.extend({
          hideSpinners: true,
          title: gettext('Error'),
          message: gettext('Oops, an unexpected server error occurred. Please try again.'),
          messageUrl: '',
          redirectLocation: serviceLocator.loginUrl(),
          logout: true,
          backdrop: true
        }, errorSettings);

        if (options.hideSpinners) {
          SpinnerHelper.hideAllSpinners();
        }

        // For GoodData if the cModule is deleted or archived we need to custom handle and show the slide
        // not available message instead of an alert/redirection to the dashboard.
        var isSingleSlidePreviewRoute = !!$location.path().match(/\/preview\/\d+/g) && !!$location.search().frameId;

        if (knownError && isSingleSlidePreviewRoute) {
          errorCb({
            error: error,
            isSingleSlidePreviewRoute: true
          });
        } else {
          if (options.message) {
            Alert.show(translate(options.title), translate(options.message));
          }

          if (options.messageUrl && $rootScope.app) {
            $rootScope.app.modal = { url: options.messageUrl, backdrop: options.backdrop };
          }

          /**
           * Refresh only when we have met the following triggers:
           *   - the error is unknown
           *   - logout is being triggered
           *   - we have not already tried to refresh
           *   - not on the ipad
           * Otherwise follow the previous logout or redirect rules
           */
          if (!knownError && options.logout && !$rootScope.refreshed && !MobileHelper.isIpad()) {
            console.log(error); // do not remove
            $location.search('refreshed', 'true');
            $exceptionHandler(new Error('ServerError'), error);
            $timeout(function() {
              $window.location.reload(true);
            });
          } else if (options.logout) {
            Auth.logoutSaveEmail();
          } else if (options.redirectLocation) {
            $location.url(options.redirectLocation);
          }
        }
      }
    }

    function checkConnection(cb) {
      if ($window.isConnected) return cb();
      SpinnerHelper.hideAllSpinners();
      $rootScope.app.modal = {
        url: 'modals/connectionLost.html',
        backdrop: 'static'
      };
    }

    function checkCanCallServiceWithoutBeingLoggedIn(cb) {
      if (!Auth.getHeaderSessionId()) {
        SpinnerHelper.hideAllSpinners();
        Auth.logoutSaveEmail();
        return;
      }
      checkConnection(cb);
    }

    function checkCanCallService(cb) {
      if (!checkIsLoggedIn()) return;
      if (!$window.mfConfig.traineeDomain) {
        SpinnerHelper.hideAllSpinners();
        Auth.logoutSaveEmail();
        return;
      }
      checkConnection(cb);
    }

    function checkIsLoggedIn() {
      if (!Auth.userIsLoggedIn()) {
        SpinnerHelper.hideAllSpinners();
        Auth.logoutSaveEmail();
        return false;
      }
      return true;
    }

    function defaultUrlParams(params) {
      params = params || {};
      params.allowNoDomain = params.allowNoDomain || false;
      var host = mfConfig.traineeDomain;
      var ipad = MobileHelper.useIpadRoutes() ? 'ipad' : null;

      if (!host && params.allowNoDomain)
        host = mfConfig.baseUrl;
      return { host: host, ipad: ipad };
    }

    return {
      checkCanCallService: checkCanCallService,
      checkCanCallServiceWithoutBeingLoggedIn: checkCanCallServiceWithoutBeingLoggedIn,
      checkConnection: checkConnection,
      checkIsLoggedIn: checkIsLoggedIn,
      defaultUrlParams: defaultUrlParams,
      errorHandler: errorHandler
    };
  }

})();
